import {
  IModalConfirmProps,
  ModalConfirm,
} from '@components/common/Modal/ModalConfirm/ModalConfirm';
import { IModalFormProps, ModalForm } from '@components/common/Modal/ModalForm/ModalForm';
import React, { ReactNode } from 'react';

export interface IModalBaseProps {
  open: boolean;
  onSubmit: (values?: any) => void;
  onCancel: () => void;
  confirmLoading?: boolean;
  centered?: boolean;
  destroyOnHidden?: boolean;
  footer?: ReactNode | null;
}

export type ModalProps = IModalFormProps | IModalConfirmProps;

export const Modal: React.FC<ModalProps> = (props: ModalProps) => {
  return props.mode == 'confirm' ? <ModalConfirm {...props} /> : <ModalForm {...props} />;
};
